module.exports = __webpack_public_path__ + "img/Lanterne_exterieure.d0d727e.jpg";